import { useEffect } from 'react';
import { FetchBaseQueryError } from '@reduxjs/toolkit/query';
import { App } from 'antd';

export const useApiErrorNotification = (
    isError: boolean,
    error: FetchBaseQueryError | any
) => {
    const { notification } = App.useApp();

    useEffect(() => {
        if (isError && error && 'data' in error) {
            const err = error as FetchBaseQueryError & {
                data?: { errors?: Record<string, string[]> };
            };

            if (err?.data?.message) {
                return notification.error({
                    message: err?.data?.message,
                });
            }

            if (err?.data?.errors) {
                Object.entries(err.data.errors).forEach(([key, messages]) => {
                    messages.forEach(message =>
                        notification.error({ message })
                    );
                });
            }
        }
    }, [isError, error, notification]);
};
